import Memoji1 from "../assests/memojis/17 (1).png";
import Memoji2 from "../assests/memojis/17 (2).png";
import Memoji3 from "../assests/memojis/17 (3).png";
import Memoji4 from "../assests/memojis/17 (4).png";
import Memoji5 from "../assests/memojis/17 (5).png";
import Memoji6 from "../assests/memojis/17 (6).png";
import Memoji7 from "../assests/memojis/17 (7).png";
import Memoji8 from "../assests/memojis/17-1.png";
import Memoji9 from "../assests/memojis/17-10.png";
import Memoji10 from "../assests/memojis/17-11.png";
import Memoji11 from "../assests/memojis/17-12.png";
import Memoji12 from "../assests/memojis/17-13.png";
import Memoji13 from "../assests/memojis/17-14.png";
import Memoji14 from "../assests/memojis/17-15.png";
import Memoji15 from "../assests/memojis/17-2.png";
import Memoji16 from "../assests/memojis/17-3.png";
import Memoji17 from "../assests/memojis/17-4.png";
import Memoji18 from "../assests/memojis/17-5.png";
import Memoji19 from "../assests/memojis/17-6.png";
import Memoji20 from "../assests/memojis/17-7.png";
import Memoji21 from "../assests/memojis/17-8.png";
import Memoji22 from "../assests/memojis/17-9.png";
import Memoji23 from "../assests/memojis/17.png";

const GetRandomMemoji = () => {
  function randomIntFromInterval(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  const memejois = [
    Memoji1,
    Memoji2,
    Memoji3,
    Memoji4,
    Memoji5,
    Memoji6,
    Memoji7,
    Memoji8,
    Memoji9,
    Memoji10,
    Memoji11,
    Memoji12,
    Memoji13,
    Memoji14,
    Memoji15,
    Memoji16,
    Memoji17,
    Memoji18,
    Memoji19,
    Memoji20,
    Memoji21,
    Memoji22,
    Memoji23,
  ];

  const randomNumber = randomIntFromInterval(0, memejois.length - 1);
  return memejois[randomNumber];
};

export default GetRandomMemoji;
